import { makeAutoObservable } from 'mobx'
import { InferenceStore } from 'store/inference/InferenceStore'

export class GeneratingStore {
  readonly video: boolean
  private _inference?: InferenceStore
  private _error = false

  constructor(video: boolean) {
    makeAutoObservable(this)
    this.video = video
  }

  get error(): boolean {
    return this._error || !!this.inference?.error
  }

  set error(value: boolean) {
    this._error = value
  }

  get inference(): InferenceStore | undefined {
    return this._inference
  }

  set inference(value: InferenceStore | undefined) {
    this._inference = value
  }
}
